import { createReducer } from 'redux-act';

import GuestsAnalyticsData from '../../models/GuestsAnalyticsData';

export interface GuestsAnalyticsReducerState {
  readonly data: GuestsAnalyticsData[];
}

const defaultState: GuestsAnalyticsReducerState = {
  data: [
    {
      options1: {
        chart: {
          stacked: true,
          stackType: '100%',
        },
        plotOptions: {
          bar: {
            horizontal: true,
          },
        },
        stroke: {
          width: 3,
          colors: ['#fff'],
        },
        title: {
          text: 'Frequent guests vs. first time visits',
        },
        xaxis: {
          categories: ['January', 'February', 'March', 'April', 'May', 'July', 'August', 'September', 'October', 'November', 'December'],
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val + 'K';
            },
          },
        },
        fill: {
          opacity: 1,
        },
        legend: {
          position: 'right',
          horizontalAlign: 'center',
          offsetY: 40,
        },
      },
      options2: {},
      series1: [
        {
          name: 'Frequent guests',
          data: [23, 45, 65, 54, 23, 64, 102, 65, 52, 64, 86, 114],
        },
        {
          name: 'First time visits',
          data: [86, 97, 45, 76, 121, 45, 64, 96, 53, 21, 75, 64],
        },
      ],
      series2: [44, 55, 41, 17, 15],
    },
  ],
};

const guestsAnalyticsReducer = createReducer<GuestsAnalyticsReducerState>({}, defaultState);

export default guestsAnalyticsReducer;
